import produce from 'immer';
import { ActionTypes } from './Form.actions';

export const initialState = {
    forms: {},
};

function getAdditionalInfo(form) {
    const fields = [
        'driverLicense',
        'educationHistory',
        'employments',
        'expectedSalary',
        'gender',
        'languages',
        'recommendingPerson',
        'workExperience',
        'availability',
        'birthday',
        'workLocations'
    ];
    const filteredForm = [];
    Object.keys(form).forEach((key) => {
        if (fields.indexOf(key) !== -1 && form[key]) {
            filteredForm.push({ ...form[key], key });
        }
    });
    const orderedFields = filteredForm.sort((a, b) => (a.order || 0) - (b.order || 0));
    return orderedFields;
}

const reducer = (state = initialState, action) => produce(state, (draft) => {
    switch (action.type) {
        case ActionTypes.fetchApplicationDetailsCompleted: {
            const { applicationId, form } = action.payload;
            draft.forms[applicationId] = state.forms[applicationId] || {};
            draft.forms[applicationId].form = { ...form, additionalInfo: getAdditionalInfo(form) };

            return draft;
        }
        default: {
            return state;
        }
    }
});
export default reducer;

